module.exports = __webpack_public_path__ + "static/media/plus_sign.2ffd6523.svg";